
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { GetAgentsResponse } from "@/models/api/system/agents";
import { SystemModule } from "@/store/modules/index";
import { AgentResource } from "../../models/api/system/agents";
import notifications from "@/lib/notifications";
import router from "@/router";
import permissions from "@/security/permissions";
const systemModule = getModule(SystemModule);

interface DefaultField {
  key: string;
  label: string;
  allowed: boolean;
  thStyle?: any;
  thClass?: any;
  tdClass?: any;
}

@Component
export default class Agents extends Vue {
  loading: boolean = false;
  agents: Array<any> = [];
  pageNumber: number = 1;
  totalItems: number = 0;
  pageSize: number = 30;
  searchName: string = "";
  isAgentModalVisible: boolean = false;
  agent: AgentResource = {
    id: null,
    name: null,
    isActive: null
  };
  fields: Array<DefaultField> = [
    {
      key: "name",
      label: "Name",
      allowed: true
    },
    {
      key: "isActive",
      label: "Active",
      allowed: true,
      thStyle: { width: '10%' }, 
      thClass: 'text-center',
      tdClass: 'text-center'
    },
    {
      key: "editAgent",
      label: "Edit Agent",
      allowed: this.hasPermission(permissions.manage.agents.edit),
      thStyle: { width: '10%' }, 
      thClass: 'text-center',
      tdClass: 'text-center'
    },
    {
      key: "editAgentConfiguration",
      label: "Edit Configuration",
      allowed: this.hasPermission(permissions.manage.agents.configurationEdit),
      thStyle: { width: '20%' }, 
      thClass: 'text-center',
      tdClass: 'text-center'
    }
  ];

  filteredFields() {
    return this.fields.filter(x => x.allowed);
  }

  @Watch("pageNumber")
  pageChanged(val) {
    this.updateAgents();
  }

  created() {
    this.updateAgents();
  }

  async updateAgents() {
    this.loading = true;
    const response: GetAgentsResponse = await systemModule.getAgents({
       pageNumber: this.pageNumber,
       pageSize: this.pageSize
     });
    this.agents = response.items;
    this.totalItems = response.totalItems;
    this.loading = false;
  }
  
  async createAgent() {
    this.agent = {
      id: null,
      name: null,
      isActive: true
    };
    this.isAgentModalVisible = true;
  }

  async saveAgent() {
    this.isAgentModalVisible = false;
    try {
      if (this.agent.id === null){
        var newAgent = await systemModule.postAgent(this.agent);
        router.push(`/admin/agents/${newAgent.id}`);      
        notifications.success('Agent Created', `Agent ${newAgent.name} created.`);
      } else {
        await systemModule.putAgent(this.agent);
        notifications.success('Agent Updated', `Agent ${this.agent.name} updated.`);
        await this.updateAgents();
      }
    } catch (error) {
      notifications.error(`Unable to create or update agent.`, error);
    }
  }

  editAgent(id: number) {
    let clone = this.agents.find(x => x.id === id);
    clone = { ...clone };

    this.agent = clone;
    this.isAgentModalVisible = true;
  }

  editAgentConfiguration(id: number) {
    router.push(`/admin/agents/${id}`);
  }
}
